export default function getProductAuthUrl(
  host: string,
  user: string,
  token: string,
  redirect: string
) {
  return `${host}/auth?UserName=${user}&Password=${token}&Continue=${redirect}`;
}
